module.exports = __webpack_public_path__ + "img/sign-69.cf658bd5.jpg";